import { useTranslation } from 'react-i18next';

import {
	BoldIcon,
	Code2Icon,
	EyeOffIcon,
	ItalicIcon,
	MessageSquareCodeIcon,
	QuoteIcon,
	StrikethroughIcon,
	UnderlineIcon,
	VariableIcon,
} from 'lucide-react';
import { KEYS } from 'platejs';
import { useEditorReadOnly, useEditorRef } from 'platejs/react';

import { FLOATING_ICON_SIZE, LinkToolbarButton, MarkToolbarButton, PLATE_KEYS, ToolbarButton } from 'features/Editor';

export function FloatingToolbarButtons() {
	const readOnly = useEditorReadOnly();
	const editor = useEditorRef();
	const { t } = useTranslation();

	return (
		<>
			{!readOnly && (
				<>
					<ToolbarButton
						onClick={() => editor.tf.toggleBlock(KEYS.blockquote)}
						tooltip={t('Цитата')}
						icon={<QuoteIcon size={FLOATING_ICON_SIZE} />}
					/>

					<MarkToolbarButton nodeType={KEYS.bold} tooltip={t('Жирный')} icon={<BoldIcon size={FLOATING_ICON_SIZE} />} />

					<MarkToolbarButton
						nodeType={KEYS.italic}
						tooltip={t('Курсив')}
						icon={<ItalicIcon size={FLOATING_ICON_SIZE} />}
					/>

					<MarkToolbarButton
						nodeType={KEYS.underline}
						tooltip={t('Подчеркнутый')}
						icon={<UnderlineIcon size={FLOATING_ICON_SIZE} />}
					/>

					<MarkToolbarButton
						nodeType={KEYS.strikethrough}
						tooltip={t('Зачеркнутый')}
						icon={<StrikethroughIcon size={FLOATING_ICON_SIZE} />}
					/>

					<MarkToolbarButton nodeType={KEYS.code} tooltip={t('Код')} icon={<Code2Icon size={FLOATING_ICON_SIZE} />} />

					<ToolbarButton
						onClick={() => editor.tf.toggleBlock(KEYS.codeBlock)}
						tooltip={t('Блок кода')}
						icon={<MessageSquareCodeIcon size={FLOATING_ICON_SIZE} />}
					/>

					<MarkToolbarButton
						nodeType={PLATE_KEYS.spoiler}
						tooltip={t('Скрытый')}
						icon={<EyeOffIcon size={FLOATING_ICON_SIZE} />}
					/>

					<LinkToolbarButton />

					<MarkToolbarButton
						nodeType={PLATE_KEYS.affiliateLink}
						tooltip={t('Партнерская ссылка')}
						icon={<VariableIcon size={FLOATING_ICON_SIZE} />}
					/>
				</>
			)}
		</>
	);
}
